var $0dfacfad01736641$exports = {};
$0dfacfad01736641$exports = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


export {$0dfacfad01736641$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
